import $ from 'jquery';
import Component from "../models/Component";
import simpleParallax from 'simple-parallax-js';

export default class Parallax extends Component {
  constructor(element, context) {
    super(element, context);
    $(() => {
      if (Modernizr.objectfit) {
        this.imageUrl = this.element.css('background-image').slice(4, -1).replace(/"/g, "");
        this.init();
      }
    });
  }

  init() {
    this.element.css('background-image', '');
    const image = $('<img class="parallax-image">').attr('src', this.imageUrl).prependTo(this.element);
    new simpleParallax(image.get(0), {
      scale: 1.3
    });
  }
}
